export default __webpack_public_path__ + "/dist/images/blocking-inactive.3036d405db014e6f8a3e67b2e360da7e.svg";